<template>
  <div>
    <vs-prompt
      title="Select legal document"
      @cancel="val = ''"
      @accept="accept"
      :active.sync="prompt"
      accept-text="Add document"
      :is-valid="validForm"
    >
      <vs-row>
        <vs-col vs-w="12">
          <div class="vx-row mb-2">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Document</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-select v-model="selectedDocument" class="w-full ml-2">
                <vs-select-item
                  :key="index.id"
                  :value="item.id"
                  :text="item.name"
                  v-for="(item, index) in selectableDocuments"
                />
              </vs-select>
            </div>
          </div>
        </vs-col>
      </vs-row>
    </vs-prompt>
  </div>
</template>

<script>
export default {
  data() {
    return {
      prompt: false,

      selectableDocuments: [],
      selectedDocument: null,
    };
  },
  computed: {
    validForm() {
      return this.name !== "";
    },
  },
  methods: {
    show(legalDocuments) {
      this.prompt = true;

      this.selectableDocuments = legalDocuments;
    },
    async accept() {
      this.$emit("documentSelected", this.selectedDocument);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
